import { Card, CardContent } from "../../components/ui/card";
import { Clock, CheckCircle, XCircle, Users } from "lucide-react";

const AttendanceStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-violet-100">
              <Users className="h-5 w-5 text-violet-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.totalEmployees || 0}</p>
              <p className="text-xs text-slate-500">Total Employees</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-emerald-100">
              <CheckCircle className="h-5 w-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.presentToday || 0}</p>
              <p className="text-xs text-slate-500">Present Today</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-red-100">
              <XCircle className="h-5 w-5 text-red-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.absentToday || 0}</p>
              <p className="text-xs text-slate-500">Absent Today</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-amber-100">
              <Clock className="h-5 w-5 text-amber-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.lateToday || 0}</p>
              <p className="text-xs text-slate-500">Late Today</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AttendanceStats;
